#import "./EntityDocumentsFields.graphql"
query AttachableTravelerDocuments(
  $first: Int
  $after: Cursor
  $travelerId: UUID!
  $documentTypeId: Int
  $orderBy: [EntityDocumentsOrderBy!]
  $filter: EntityDocumentFilter
) {
  attachableTravelerDocuments(
    first: $first
    after: $after
    documentTypeId: $documentTypeId
    orderBy: $orderBy
    filter: $filter
    travelerId: $travelerId
  ) {
    nodes {
      ...EntityDocumentsFields
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
  }
}
